import sidebar from '@/config/sidebars/adminHubspot'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminHubspotProvisionings = {
  index: async(props) => {
    const { default: Index } = await import('@/vue_widgets/admin/hubspot/provisionings/index.vue')
    createVueApp(Index, { props, sidebar })
  }
}
